import { DEVICES } from '@constants/global'
import { COLORS } from '@styles/colors'
import { FONTS, text2XL, text3XL, text5XL } from '@styles/fonts'
import styled, { css } from 'styled-components'

export const Hero = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  overflow: hidden;
  background-position: top center;
  background-size: cover;
  height: 100dvh;

  ${({ withSearchForm }) =>
    !withSearchForm &&
    css`
      // max-height: 600px;
    `}

  ${({ withSearchForm }) =>
    withSearchForm &&
    css`
      @media ${DEVICES.mobile} {
        ${HeroContent} {
          justify-content: flex-end;
        }
      }
    `}

  &:after {
    position: absolute;
    content: '';
    display: block;
    z-index: 3;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.45);
  }

  ${({ bgImage }) =>
    bgImage &&
    css`
      background-image: url(${bgImage});
    `}

  ${({ bgPosition }) =>
    bgPosition &&
    css`
      background-position: ${bgPosition};
    `}

  @media ${DEVICES.mobile} {
  }

  @media ${DEVICES.mobile} {
    overflow: unset;

    .property-search-form {
    }

    .bp-appraisal-button {
      display: none;
    }
  }

  ${({ fullscreen }) =>
    fullscreen &&
    css`
      @media ${DEVICES.mobile} {
      }
    `}

  ${({ maxHeight }) =>
    maxHeight &&
    css`
      // max-height: ${maxHeight};
    `}
`

export const VideoBg = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`

export const Video = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

export const HeroContent = styled.div`
  ${({ position }) =>
    position &&
    position === 'bottom' &&
    css`
      justify-content: flex-end;
    `}

  color: ${COLORS.white};
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 80px;
  padding: 110px 42px;
  position: relative;
  z-index: 4;

  ${({ withSearchForm }) =>
    !withSearchForm &&
    css`
      justify-content: center;
    `}

  @media ${DEVICES.tablet} {
    padding: 80px 42px;
  }

  @media ${DEVICES.tabletMini} {
    padding: 60px 16px;
  }

  @media ${DEVICES.mobile} {
    padding: 62px 16px 0;
    gap: 20px;
  }
`

export const HeroContentInner = styled.div`
  ${({ center }) =>
    center &&
    css`
      @media ${DEVICES.mobile} {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }
    `}
`

export const HeroTitle = styled.h1`
  ${text5XL};
  font-family: ${FONTS.medium};
  text-transform: uppercase;
  max-width: 830px;
  text-align: center;
  margin: 0 auto;

  @media ${DEVICES.mobile} {
    max-width: 100%;
    ${text3XL};
    letter-spacing: 10px;
  }
`

export const HeroSubTitle = styled.p`
  font-family: ${FONTS.regular};
  max-width: 765px;
  text-align: center;
  margin: 28px auto 0;

  @media ${DEVICES.mobile} {
    padding-top: 4px;
  }
`

export const HeroDescription = styled.p`
  line-height: 22px;
  text-align: center;
  max-width: 765px;
  margin: 28px auto 0;

  @media ${DEVICES.tabletMini} {
    margin-top: 6px;
  }
`

export const TagWrap = styled.div`
  margin-bottom: 12px;
`

export const HeroWrapper = styled.div`
  ${({ office }) =>
    office &&
    css`
      margin-top: -120px;

      @media ${DEVICES.tablet} {
        margin-top: 0;
      }
    `}

  ${({ carrer }) =>
    carrer &&
    css`
      ${HeroTitle} {
        ${text2XL};
      }
    `}
`
